import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PosterUpload from '../components/PosterUpload';
import { Poster } from '../types';
import { api } from '../services/api';
import Button from '../components/ui/Button';

export default function Home() {
  const [error, setError] = useState<string | null>(null);
  const [isLoadingDemo, setIsLoadingDemo] = useState(false);
  const navigate = useNavigate();

  const handleUploadComplete = (poster: Poster) => {
    navigate(`/edit/${poster.id}`);
  };

  const handleTryDemo = async () => {
    setIsLoadingDemo(true);
    setError(null);
    try {
      const demoPoster = await api.getDemoPoster();
      navigate(`/edit/${demoPoster.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load demo poster');
    } finally {
      setIsLoadingDemo(false);
    }
  };

  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl text-center mb-4 
                        font-display font-bold text-neutral-900">
          ASH25 Poster Platform
        </h1>
        <p className="text-lg sm:text-xl text-center mb-10 text-neutral-600 
                      leading-relaxed">
          Convert your research posters into interactive, shareable digital pages
        </p>

        {/* Try Demo Button */}
        <div className="mb-6 text-center">
          <Button
            variant="secondary"
            onClick={handleTryDemo}
            disabled={isLoadingDemo}
            className="text-base sm:text-lg px-6 py-3"
          >
            {isLoadingDemo ? 'Loading Demo...' : '🎯 Try Demo Poster'}
          </Button>
          <p className="text-sm text-neutral-500 mt-2">
            See how it works with a sample poster
          </p>
        </div>

        {/* Divider */}
        <div className="relative mb-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-neutral-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-4 bg-white text-neutral-500">or</span>
          </div>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-800 
                         px-4 py-3 rounded-lg mb-6">
            {error}
          </div>
        )}

        <PosterUpload onUploadComplete={handleUploadComplete} onError={setError} />
      </div>
    </div>
  );
}
